export default {
  productName: 'Nom du produit',
  pay: 'PAYER',
  payTokenLack: "Requête code de paiement nécessaire! S'il vous plaît contactez-nous pour obtenir de l'aide",
  payTokenInvalid: "Code de paiement ne correspond pas ! S'il vous plaît contactez-nous pour obtenir de l'aide",
  noPayChannel: 'Pas de canal de paiement disponible',
  currencyMismatch: 'Impossible de procéder à la transaction, opération erronée, veuillez essayer avec un autre moyen de paiement ou contactez-nous.',
  networkError: 'Serveur internet indisponible, veuillez réessayer plus tard.',
  invokeTimeoutNotice: "Le resultat du paiement est toujours en cours... prière vérifier l'etat de votre commande et essayer plus tard.",
  ok: 'OK',
  paymentMethodNotSupported: "Ce mode de paiement n'est pas supporté, veuillez en essayer un autre.",
  enterCompleteInfo: "S'il vous plaît entrer les informations complètes.",
  enterCorrectInfo: "S'il vous plaît entrez le XXX correct",
  sendOtpCode: 'ENVOYER',
  textOnairNext: 'SUIVANT',
  voteCancel: 'ANNULER',
  paymentSuccessful: 'Paiement Réussi',
  paymentSuccessfulDesc: 'Merci pour votre paiement. Votre commande a été payée avec succès. S\'il vous plaît cliquez sur "OK" si vous n\'êtes pas redirigé dans les 10s.',
  paymentFailed: 'Paiement échoué',
  refresh: 'RAFRAÎCHIR',
  orderIdEmpty: "L'ordre id est vide, demande invalide. S'il vous plaît contactez-nous pour obtenir de l'aide",
  waitingMessage: 'Votre paiement est en cours merci de patienter un instant',
  resultTimeoutNotice:
    "Délai de transaction expiré, nous sommes toujours en train d'effectuer le paiement et cela pourrait prendre plus de temps. Le résultat sera immédiatement actualisé,merci de patienter."
}
